import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LayoutComponent, NavLink, RECIPIENT_PATHS } from 'shared-frontend';
import { HeaderComponent, FooterComponent, NavBarComponent } from 'shared-frontend';
import { PERMISSION_SETS } from './core/roles.constants';
import { NEWSLETTER_HEADER_PATHS } from './core/app.paths';

@Component({
  selector: 'app-root',
  standalone: true,
  // imports: [
  //   FooterComponent,
  //   HeaderComponent,
  //   NavBarComponent,
  //   LayoutComponent,
  //   RouterOutlet
  // ],
  imports: [RouterOutlet, LayoutComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  navLinks: NavLink[] = [
    // { label: 'Home', route: '', icon: 'glyphicon glyphicon-home', roles: PERMISSION_SETS.ADMIN },
    { label: 'Create Announcement', icon: 'glyphicon glyphicon-home', route: NEWSLETTER_HEADER_PATHS.create, roles: PERMISSION_SETS.ADMIN },
    { label: 'List Announcements', route: NEWSLETTER_HEADER_PATHS.list, roles: PERMISSION_SETS.ADMIN },
    { label: 'Create Recipient', route: RECIPIENT_PATHS.create, roles: PERMISSION_SETS.ADMIN },
    { label: 'List Recipients', route: RECIPIENT_PATHS.list, roles: PERMISSION_SETS.ADMIN },
    { label: 'Whoami', route: '/whoami', roles: PERMISSION_SETS.SANDRA  },
  ];
}
